import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { PopupSubmitComponent } from '../popup-submit/popup-submit.component';


@Component({
  selector: 'app-review-submit',
  templateUrl: './review-submit.component.html',
  styleUrls: ['./review-submit.component.scss']
})

export class ReviewSubmitComponent {
  userInfo: any = localStorage.getItem("userInfo");
  userInfo1: any = localStorage.getItem("searchedPlaces");

  private map!: google.maps.Map;
  private markers: google.maps.Marker[] = [];
  private infoWindows: google.maps.InfoWindow[] = [];

  reviewForm: FormGroup;
  // popupDialogRef: MatDialogRef<PopupComponent> | undefined;
  reviewsubmitDialogRef: MatDialogRef<PopupSubmitComponent> | undefined;
  constructor(public dialog: MatDialog, private fb: FormBuilder) {
    this.userInfo = JSON.parse(this.userInfo);
    this.reviewForm = this.fb.group({
      firstname: [this.userInfo.addressDetails.firstname, [Validators.required]],
      lastname: [this.userInfo.addressDetails.lastname, [Validators.required]],
      emailaddress: [this.userInfo.addressDetails.emailaddress, [Validators.required]],
      phonenumber: [this.userInfo.addressDetails.phonenumber, [Validators.required]],
      streetaddress: [this.userInfo.addressDetails.streetaddress, [Validators.required]],
      city: [this.userInfo.addressDetails.city, [Validators.required]],
      state: [this.userInfo.addressDetails.state, [Validators.required]],
      county: [this.userInfo.addressDetails.county, [Validators.required]],
      zipcode: [this.userInfo.addressDetails.zipcode, [Validators.required]],
      nopotholeNumber: [this.userInfo.additionalInfoDetails.nopotholeNumber, [Validators.required]],
      pothole: [this.userInfo.additionalInfoDetails.pothole, [Validators.required]],
      potholesize: [this.userInfo.additionalInfoDetails.potholesize, [Validators.required]],
      locationdetails: [this.userInfo.additionalInfoDetails.locationdetails, [Validators.required]],
      furtherdetails: [this.userInfo.additionalInfoDetails.furtherdetails, [Validators.required]],
      // photo: [this.userInfo.additionalInfoDetails.photo, [Validators.required]]
    });

  }
  @Output() serviceTypeDetailsOutputEvent = new EventEmitter();
  gotoNext(data: object) {
    this.serviceTypeDetailsOutputEvent.emit(data)
  }
  reviewSubmit() {
    this.userInfo["srID"] = Math.floor((Math.random() * 1000000000000));
    this.userInfo["srReportDate"] = new Date();
    this.userInfo["srStatus"] = 'UnResolved';
    let locationInfo:any = localStorage.getItem("locationInfo");
    locationInfo = (locationInfo)? JSON.parse(locationInfo) : "";
    this.userInfo["locationInfo"] = locationInfo;
    localStorage.setItem("submitSrDetails", JSON.stringify(this.userInfo));
    let userListSubmit = localStorage.getItem("userListSubmit");
    let ServiceTypeInfoSubmit:any = localStorage.getItem("ServiceTypeInfo");
    let userList = (userListSubmit)? JSON.parse(userListSubmit) : [];
    let usrListInfo = localStorage.getItem("userList");
    if(usrListInfo){
      userList = JSON.parse(usrListInfo);
    }
    ServiceTypeInfoSubmit = (ServiceTypeInfoSubmit)?JSON.parse(ServiceTypeInfoSubmit) : {serviceDetails: {content:"",department:"" } };
    if(ServiceTypeInfoSubmit.serviceDetails && ServiceTypeInfoSubmit.serviceDetails.content){
      this.userInfo["content"] = ServiceTypeInfoSubmit.serviceDetails.content;
      this.userInfo["department"] = ServiceTypeInfoSubmit.department.name;
    }
    let userAddress = [];
    if(this.userInfo.addressDetails){
      if(this.userInfo.addressDetails.streetaddress){
        userAddress.push(this.userInfo.addressDetails.streetaddress);
      }
      if(this.userInfo.addressDetails.city){
        userAddress.push(this.userInfo.addressDetails.city);
      }
      if(this.userInfo.addressDetails.state){
        userAddress.push(this.userInfo.addressDetails.state);
      }
      if(this.userInfo.addressDetails.county){
        userAddress.push(this.userInfo.addressDetails.county);
      }
      if(this.userInfo.addressDetails.zipcode){
        userAddress.push(this.userInfo.addressDetails.zipcode);
      }
    }
    this.userInfo["serviceAddress"] = userAddress.length ? userAddress.join(', '):"";
    this.userInfo["serviceOn"] = "Streets - Pothole in Street";
    userList.push(this.userInfo);
   
    // this.addMarkersForSearchedPlaces(this.map);

    
    localStorage.setItem("userListSubmit", JSON.stringify(userList));
    this.dialog.open(PopupSubmitComponent, {
      width: '400px'
    });
  }
  addMarkersForSearchedPlaces(map: google.maps.Map) {
    const locStorage: any = localStorage.getItem('userListSubmit');

    if (locStorage) {
      const storedPlaces: any[] = JSON.parse(locStorage);

      storedPlaces.forEach((place) => {
        if (typeof place === 'object' && place.lat && place.lon) {
          const lat = parseFloat(place.lat);
          const lon = parseFloat(place.lon);

          if (!isNaN(lat) && !isNaN(lon)) {
            const location = new google.maps.LatLng(lat, lon);
            const marker = new google.maps.Marker({
              map,
              position: location,
              title: place.address,
            });
            // //  const _self = this;
            //  if (this.markers.length > 0) {
            //   for (let i = 0; i < this.markers.length; i++) {
            //     this.markers[i].setMap(null);
            //   }
            //   // this.markers = [];
            // }

            const infoWindow = new google.maps.InfoWindow({
              content: `
                <div>
                  <strong>State:</strong> ${place.state || 'N/A'}<br>
                  <strong>City:</strong> ${place.city || 'N/A'}<br>
                  <strong>Country:</strong> ${place.country || 'N/A'}
                </div>
              `,
            });
            this.markers.push(marker);

            this.infoWindows.push(infoWindow);

            marker.addListener('click', () => {

              this.infoWindows.forEach((info, i) => {
                if (i !== this.markers.indexOf(marker)) {
                  info.close();
                }
              });

              infoWindow.open(map, marker);
            });
          }
        }
      });
    }
  }
}
